@if (showCard) {
  <div
    [@showInOutAnimation]
    class="contact-card-wrapper tw:relative"
    role="button"
    tabindex="0"
    (keydown.enter)="toggleCardSize()"
    (keydown.space)="$event.preventDefault(); toggleCardSize()"
    (click)="toggleCardSize()"
  >
    <div class="contact-card tw:pt-1">
      <div class="tw:flex tw:justify-center">
        <div class="handle tw:h-1 tw:w-8 tw:rounded-md"></div>
      </div>
      <red-contact-card-header></red-contact-card-header>
    </div>
    <div
      [@expandCollapse]="showFullCard"
      class="contact-card-large tw:absolute tw:bottom-0 tw:left-0 tw:w-full tw:rounded-lg tw:pt-1"
    >
      <div class="tw:flex tw:justify-center">
        <div class="handle tw:h-1 tw:w-8 tw:rounded-md"></div>
      </div>
      <red-contact-card-content></red-contact-card-content>
    </div>
  </div>
}
